import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CompanyService } from 'app/services/company.service';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrl: './supplier.component.scss',
})
export class SupplierComponent implements OnInit {
  supplierContent: SafeHtml;
  isLoading: boolean = false;
  
  constructor(
    private companyService: CompanyService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.getSupplierContent();
  }
  
  getSupplierContent() {
    this.isLoading = true;
    this.companyService.getSupplierContent().subscribe(
      (data: string) => {
        this.supplierContent = this.sanitizer.bypassSecurityTrustHtml(data);
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching supplier content', error);
        this.isLoading = false;
      }
    );
  }
}